import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
// const Language = lazy(() => import("../pages/Language/Language"));
const LoginPage = lazy(() => import("../pages/Login/LoginPage"));
// const Live = lazy(() => import("../pages/Live/Live"));
// const Offer = lazy(() => import("../pages/Offers/Offer"));
// const Notification = lazy(() => import("../pages/Notifications/Notification"));
// const Skill = lazy(() => import("../pages/Skill/Skill"));
// const Astrologer = lazy(() => import("../pages/Astrologer/Astrologer"));
// const AstroLogerRequest = lazy(
//   () => import("../pages/AstrologerRequest/AstrologerRequest"),
// );
// const User = lazy(() => import("../pages/User/User"));
const PageNotFound = lazy(() => import("../pages/PageNotFound/PageNotFound"));
// const Banner = lazy(() => import("../pages/Banner/Banner"));
// const Blog = lazy(() => import("../pages/Blog/Blog"));
// const BankRequest = lazy(() => import("../pages/BankRequest/BankRequest"));
// const Category = lazy(() => import("../pages/Category/Category"));
// const Product = lazy(() => import("../pages/Product/Product"));
// const ProductBookingList = lazy(
//   () => import("../pages/ProductBookingList/ProductBookingList"),
// );
// const Puja = lazy(() => import("../pages/Puja/Puja"));
// const SubAdmin = lazy(() => import("../pages/SubAdmin/SubAdmin"));
// const CallHistory = lazy(() => import("../pages/CallHistory/CallHistory"));
// const Gst = lazy(() => import("../pages/Gst/Gst"));
// const Gift = lazy(() => import("../pages/Gift/Gift"));
// const SiteSetting = lazy(() => import("../pages/SiteSetting/SiteSetting"));
const DashboardPage = lazy(() => import("../pages/Dashboard/Dashboard"));
// const PoojaBookingPage = lazy(
//   () => import("../pages/PoojaBookingList/PoojaBookingPage"),
// );
// const ChadawaBookingPage = lazy(
//   () => import("../pages/Chadawa/ChadawaBookingPage"),
// );
// const ChadawaBookingListPage = lazy(
//   () => import("../pages/ChadawaBookingList/ChadawaBookingListPage"),
// );
// const Editor = lazy(() => import("../pages/Editor/Editor"));
// const RedeemRequest = lazy(
//   () => import("../pages/RedeemRequest/RedeemRequest"),
// );
// const RechargeOffer = lazy(
//   () => import("../pages/RechargeOffer/RechargeOffer"),
// );
// const QueryForm = lazy(() => import("../pages/QueryForm/QueryForm"));
// const InactiveUser = lazy(() => import("../pages/InactiveUser/InactiveUser"));

// const ForgotPassword = lazy(
//   () => import("../pages/Login/components/ForgotPassword"),
// );

const JkmQuery = lazy(() => import("../pages/JKMQuery/JkmQuery"));

const routes = [
  {
    path: "/login",
    // element: <LoginPage />,
    element: (
      <Suspense fallback={<div>loading...</div>}>
        <LoginPage />
      </Suspense>
    ),
    isPublic: true,
  },

  {
    path: "/",
    element: (
      <Suspense fallback={<div>loading...</div>}>
        <DashboardPage />
      </Suspense>
    ),
    isProtected: true,
  },

  // {
  //   path: "/forgot-password",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <ForgotPassword />
  //     </Suspense>
  //   ),
  //   isPublic: true, 
  // },
  // {
  //   path: "/utility/language",
  //   element: (
  //     <Suspense fallback={<div>Loading....</div>}>
  //       <Language />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/utility/skill",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Skill />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/category",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Category />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/product",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Product />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/product-booking-list",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <ProductBookingList />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/astrologer",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Astrologer />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/astroLogerRequest",
  //   element: (
  //     <Suspense fallback={<div>Loading...</div>}>
  //       <AstroLogerRequest />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/inactive-user",
  //   element: (
  //     <Suspense fallback={<div>Loading...</div>}>
  //       <InactiveUser />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/user",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <User />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/cms/banner",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Banner />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/cms/blog",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Blog />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/cms/site-setting",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <SiteSetting />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/pooja",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Puja />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/sub-admin",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <SubAdmin />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
  // {
  //   path: "/callHistory",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <CallHistory />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/gst",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Gst />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/gift",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Gift />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/recharge-offer",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <RechargeOffer />
  //     </Suspense>
  //   ),
  //   isPublic: true,
  // },

  // {
  //   path: "/pooja-booking-list",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <PoojaBookingPage />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  {
    path: "*",
    element: (
      <Suspense fallback={<div>loading...</div>}>
        <PageNotFound />
      </Suspense>
    ),
    isPublic: true, 
  },

  // {
  //   path: "/Chadawa-Booking-Page",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <ChadawaBookingPage />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/queryform",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <QueryForm />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  {
    path: "/jkm-query",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <JkmQuery />
      </Suspense>
    ),
    isProtected: true,
  },

  // {
  //   path: "/editor",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Editor />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/Chadawa-Booking-List-Page",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <ChadawaBookingListPage />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/live",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Live />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/bank-request",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <BankRequest />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/redeem-request",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <RedeemRequest />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/utility/offers",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Offer />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },

  // {
  //   path: "/utility/notifications",
  //   element: (
  //     <Suspense fallback={<div>loading...</div>}>
  //       <Notification />
  //     </Suspense>
  //   ),
  //   isProtected: true,
  // },
];

export default routes;
